import React, { memo, useState } from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  Button,
  IconButton,
  TextField,
  Autocomplete,
  Paper,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InputField from "../formElements/InputField";
import { useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { createAccountGroupMaster } from "../../graphql";
import { showErrorSnackbar, showSuccessSnackbar } from "../snackBar/snakbar";
import { useDispatch, useSelector } from "react-redux";
import { useCreateAccountGroupMasterMutation, useListGroupMasterQuery } from "../../redux/apis/accountGroupMaster.api";
import { useListAccountMasterv2Query } from "../../redux/apis/accountMaster.api";
import useSaveModalShortcut from "../../pages/PrimeFigma/Components/useSaveModalShortcut";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  // p: 4,
  outline: "none",
  // minWidth: "500px",
  width: { xs: "90%", sm:"500px"},
  // width: "90%",
  height:"250px"
};

// let data = []
// let data = JSON.parse(localStorage.getItem('ledgeraccounts'));

const CreateGroup = ({
  open,
  setOpen,
  groupName,
  setNewGroupVal,
  padding,
  selectedRow,
  setGroupData,
  disableGroupSleection,
  groups = [],
  getGroupMaster,
  setNewId,
  setParentId,
  typeCD,
  setDefaultGroupID,
  setAccountTypeCD,
  setOpenBankAccountModal
}) => {
  let [options, setOptions] = useState([]);
  const [loader,setLoader] = useState(false)
  const dispatch = useDispatch();

  const { data: groupMaster, isLoading, isError } = useListGroupMasterQuery();

  const {
    data: AccountMasterList,
    isLoading: isAccountMasterLoading,
    isError: AccountMasterError,
    refetch: refetchAccountMasterList,
  } = useListAccountMasterv2Query(undefined, {
    refetchOnMountOrArgChange: true,
  });


  groups = groups == undefined ? groupMaster : groups;

  let randomNum = Math.floor(Math.random() * 100 + 1);
  let timeStamp = Math.floor(new Date().getTime() / 1000);
  let randomNumber = randomNum + timeStamp.toString().slice(3, 10);
  const INITIAL_STATE = {
    group: "",
    name: "",
    errorStatus: {
      group: false,
      name: false,
    },
    errorFields: {
      group: "",
      name: "",
    },
  };
  const [state, setState] = useState(INITIAL_STATE);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (value == "") {
      setState((prev) => ({
        ...prev,
        [name]: value,
        ["errorStatus"]: {
          ...prev.errorStatus,
          [name]: true,
        },
        ["errorFields"]: {
          ...prev.errorFields,
          [name]: name === "name" ? "Group Name" + " is Required" : "Group is Required ",
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        [name]: value,
        ["errorStatus"]: {
          ...prev.errorStatus,
          [name]: false,
        },
        ["errorFields"]: {
          ...prev.errorFields,
          [name]: "",
        },
      }));
    }
  };

  const companyDetails = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      name: "",
      group: groupName,
    }));
    // if (options.length > 0)
    let groupData = groups;
    let GSTArrayValues = [31, 32, 33];
    let setArrayAll =
      companyDetails?.relatedcompanydetailsnew?.[0]?.registrationtype !== 1
        ? [...groupData]
        : groupData.filter((e) => !GSTArrayValues.includes(e?.accountgroupid));
    setArrayAll?.sort((a, b) =>
      a?.accountgroupname?.localeCompare(b?.accountgroupname)
    );
    setArrayAll?.forEach((obj) => {
      createKey(obj);
    });

    return () => {
      setOptions([]);
    };
  }, [open]);

  function createKey(obj) {
    const newOption = {
      name: obj?.accountgroupname,
      value: obj?.accountgroupid,
    };

    setOptions((prevOptions) => [...prevOptions, newOption]);
  }

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
      setState(INITIAL_STATE);
    }
  };

  const isNameDuplicate = (list, nameKey, inputName) =>
    list?.some(item =>
      item?.[nameKey]?.toLowerCase()?.trim() === inputName?.toLowerCase()?.trim()
    );

  const normalizeString = str => str?.toLowerCase()?.trim() || '';

  function formValidation(data) {
    let isvalid = true;
    let obj = { ...state };
    Object.keys(data)?.map((key) => {
      if (key === "name") {
        const normalizedName = normalizeString(state.name);
        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.name = "Group Name is Required";
          obj.errorStatus.name = true;
        } else if (isNameDuplicate(groups, "accountgroupname", normalizedName)) {
          isvalid = false;
          obj.errorFields.name = "Group Name Already Exists";
          obj.errorStatus.name = true;
        } else if (isNameDuplicate(AccountMasterList, 'accountname', normalizedName)) {
          isvalid = false;
          obj.errorFields.name = "This name already exists in the ledger";
          obj.errorStatus.name = true;
        } else {
          // isvalid=true;
          obj.errorFields.name = "";
          obj.errorStatus.name = false;
        }
      }
      if (key === "group") {
        if (data[key] == "" || data[key] == undefined) {
          isvalid = false;
          obj.errorFields.group = "Group is Required";
          obj.errorStatus.group = true;
        } else {
          // isvalid=true;
          obj.errorFields.group = "";
          obj.errorStatus.group = false;
        }
      }
    });
    setState(obj);
    return isvalid;
  }
  const [createGroupMaster] = useCreateAccountGroupMasterMutation();

  async function saveChanges() {
    try {
      const { group, name } = state;
      const formData = {
        group,
        name,
      };
      if (formValidation(formData)) {
        try {
          setLoader(true)
          let data;
          groups?.map((group) => {
            if (group?.accountgroupid === state.group) {
              data = {
                accounttypecd: group.accounttypecd,
                accountgroupname: state.name,
                accountparentgroupid: state.group,
              };
            }
          });

          const resAccountMaster = await createGroupMaster({ createAccountGroupMasterInput: data });
          setNewId(resAccountMaster.data.accountgroupid);
          setLoader(false)
          if (
            resAccountMaster?.data?.statuscode ==
            "Error"
          ) {
            setOpen(false);
            showErrorSnackbar(
              resAccountMaster?.data?.statusmessage
            );
          } else {
            setAccountTypeCD(resAccountMaster.data.accounttypecd)
            setNewGroupVal(resAccountMaster.data.accountgroupid)
            // console.log(resAccountMaster.data.path?.split("/"),"=======>pathhh")
            setDefaultGroupID(resAccountMaster.data.path?.split("/"))
            
            if (resAccountMaster?.data != null) {
              // if (setNewId !== undefined) {
              //   setNewId(
              //     resAccountMaster.data.accountgroupid
              //   );
              // }
              if (setParentId !== undefined) {
                setParentId(
                  resAccountMaster.data
                    ?.accountparentgroupid
                );
              }

              showSuccessSnackbar("Group Created Successfully");
              setOpen(false);

              // getGroupMaster();
            }
          }
        } catch (e) {
          setOpen(false);
        }
      }
    } catch (e) {
      console.log(e, "error");
    } finally {
    }
  }

  useSaveModalShortcut(saveChanges)
  
  const [autocompleteOpen, setAutocompleteOpen] = useState(false);
  useEffect(() => {
    if (open) {
      document.getElementById("Name")?.focus();
    }
  }, [open]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Paper
          sx={style}
          onKeyDown={(e) => {
            if (e.key == "Enter" && !autocompleteOpen) {
              saveChanges();
            }
          }}
        >
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Add Group
                <IconButton
                  aria-label="delete"
                  className="zz"
                  onClick={handleClose}
                >
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              padding: { xs: "5px", sm: "15px" },
              // height:{xs:"400px",sm:'auto'},
            }}
          >
            <Box>
              <Box sx={{ mb: 2 }}>
                <TextField
                  id="Name"
                  error={state?.errorStatus?.name}
                  fullWidth
                  required={true}
                  state={state}
                  name="name"
                  placeholder="New Group Name"
                  size="small"
                  type="text"
                  value={state.name}
                  onChange={(e) => handleChange(e)}
                  onInput={(e) => {
                    if (e.target.value.length > 50) {
                      e.target.value = e.target.value.slice(0, 50); // Limit input to 30 characters
                    }
                  }}
                />
                <Typography
                  sx={{
                    marginTop: "2px",
                    marginLeft: "10px",
                    marginBottom: "0px",
                    fontSize: "11px",
                    color: "danger.main",
                  }}
                >
                  {state?.errorFields.name}
                </Typography>
              </Box>
              <Box sx={{}}>
                <Autocomplete
                  onOpen={() => setAutocompleteOpen(true)}
                  onClose={() => setAutocompleteOpen(false)}
                  openOnFocus
                  disablePortal
                  id="group-autocomplete"
                  options={options} // Assuming 'options' is an array of objects with 'name' and 'value' keys
                  getOptionLabel={(option) => option.name} // Specifies how to extract the label from each option
                  value={
                    options.find((option) => option.value === state.group) ||
                    null
                  } // Sets the current value based on the matching option
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "group",
                        value: newValue ? newValue.value : "",
                      },
                    });
                    if (newValue.value === 17 || newValue.value === 29) {
                      setOpenBankAccountModal(true);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Group"
                      error={state.errorStatus.group}
                      required
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        "& .MuiInputBase-root": { fontSize: "14px" },
                        "& .MuiInputLabel-root": {
                          fontSize: "14px",
                          color: "input.font",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "input.border",
                        },
                        "& .MuiFormLabel-root.Mui-focused": {
                          color: "input.font",
                        },
                        ".MuiInputLabel-asterisk": {
                          color: "danger.main",
                        },
                      }}
                    />
                  )}
                />
                <Typography
                  sx={{
                    marginTop: "2px",
                    marginLeft: "10px",
                    marginBottom: "0px",
                    fontSize: "11px",
                    color: "danger.main",
                  }}
                >
                  {state?.errorFields.group}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              // padding : "15px",
              // width:'100%',
              display: "flex",
              justifyContent: "space-between",
              // flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Button
              disableRipple={false}
              onClick={handleClose}
              variant="outlined"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              Cancel
            </Button>
            <Button
              onClick={saveChanges}
              variant="contained"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              {loader ? <CircularProgress color="inherit" size="15px"/> : "Save" }

            </Button>
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default memo(CreateGroup);
